import {Component, OnInit, ViewChild} from '@angular/core';
import {PrefixGroupsSearchComponent} from './prefix-groups-search/prefix-groups-search.component';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {
  PrefixGroupsApiService
} from '../../../services/api/settings/call-flow-configurations/prefix-groups/prefix-groups-api.service';
import {DisplayedColumnInf} from '../../../interfaces/common/table/displayed-column-inf';
import {PageEvent} from '@angular/material/paginator';
import {ServerPageRequest} from '../../../classes/common/table/server-page-request';
import {ArmTableComponent} from '../../../components/arm-table/arm-table.component';
import {SearchTermDefinitionInf} from '../../../interfaces/common/search/search-term-definition-inf';
import Search from '../../../utils/search';
import {AcDialogService} from 'ac-infra';
import {PrefixGroupsDialogComponent} from './prefix-groups-dialog/prefix-groups-dialog.component';
import _ from 'lodash';
import {LoaderService} from '../../../services/common/loader-service/loader.service';
import {SnackBarService} from '../../../services/common/snack-bar/snack-bar.service';
import {LogicalConjunctionService} from '../../../services/common/logical-conjunction/logical-conjunction.service';
import {ConfirmationDialogComponent} from '../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {RoleTypeEnum} from '../../../services/enums/role-type.enum';

@Component({
  selector: 'prefix-groups',
  templateUrl: './prefix-groups.component.html',
  styleUrls: ['./prefix-groups.component.scss']
})
export class PrefixGroupsComponent implements OnInit {

  @ViewChild(ArmTableComponent) armTable;

  displayedColumns: Array<DisplayedColumnInf> = [
    {name: 'name', display: 'Name', selected: true, width: 150},
    {name: 'type', display: 'Type', selected: true, width: 100},
    {name: 'values', display: 'Values', selected: true, width: 400},
  ];

  prefixTypeOptions = [
    {text: 'Prefix', value: 'PREFIX'},
    {text: 'Number', value: 'NUMBER'}
  ];

  data = {elements: [], totalElements: 0};
  selection: any;
  prefixGroupsSearchComponent = PrefixGroupsSearchComponent;
  search: any;
  searchData: any;
  searchTerms: SearchTermDefinitionInf[] = [
    {term: 'name', operator: ':', displayName: 'Name'},
    {term: 'value', operator: ':', displayName: 'Value'},
    {term: 'match', operator: ':', displayName: 'Value'},
    {term: 'type', operator: '=', displayName: 'Type', displayValue: Search.getOptionValue(this.prefixTypeOptions)},
  ];
  isUnauthorized: boolean;

  serverPageRequest: ServerPageRequest = new ServerPageRequest({
    pageIndex: 0,
    pageSize: 25,
    length: 0
  });

  constructor(private userPrivilege: UserPrivilegeService,
              private prefixGroupsApiService: PrefixGroupsApiService,
              private acDialogService: AcDialogService,
              private loaderService: LoaderService,
              private snackBarService: SnackBarService,
              private logicalConjunctionService: LogicalConjunctionService,
              private dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.isUnauthorized = !this.userPrivilege.isAuthorized(RoleTypeEnum.PREFIX_GROUP);
    this.refresh();
    this.setSearchOptions();
  }

  onSelection(selection: any): void {
    this.selection = selection;
  }

  pageChanged(pageInfo: PageEvent): void {
    this.serverPageRequest = new ServerPageRequest(pageInfo);
    this.refresh();
  }

  onSearch(data: any): void {
    this.armTable.firstPage();
    this.serverPageRequest.firstPage();
    this.search = data;

    this.refresh();
  }

  addItem(): void {
    const dialogData = {
      isEditMode: false,
      selectedItem: {name: '', type: 'PREFIX', values: []},
      prefixTypeOptions: this.prefixTypeOptions
    };

    this.acDialogService.open(PrefixGroupsDialogComponent, {
      dialogData,
      title: 'Add prefix group',
      onSubmit: () => {
        return this.prefixGroupsApiService.addPrefixGroup(dialogData.selectedItem).toPromise().then(() => {
          this.refresh();
          this.snackBarService.display(`${dialogData.selectedItem.name} successfully added`);
        });
      }
    });
  }

  removeItem(): void {
    const confirmationMessage = `Are you sure you want to delete ${(this.selection.length === 1) ?
      `the prefix group: "${this.selection[0].name}"` :
      `${this.selection.length} prefix groups: ${this.logicalConjunctionService.generateAndDescription(this.selection, 'name')}`} ?`;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: confirmationMessage
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      this.prefixGroupsApiService.deletePrefixGroups(this.selection.map(group => group.id)).subscribe(() => {
        dialogRef.close();
        this.refresh();
        this.snackBarService.display(`${this.selection.name} successfully deleted`);
      }, () => {
        dialogRef.close();
      });
    });
  }

  refresh(): void {
    const params = {...this.search, ...this.serverPageRequest};
    this.prefixGroupsApiService.getPrefixGroups(params).subscribe(data => {
      this.data = data;
    });
  }

  editItem(): void {
    const dialogData = {
      isEditMode: true,
      selectedItem: _.cloneDeep(this.selection[0]),
      prefixTypeOptions: this.prefixTypeOptions
    };

    this.acDialogService.open(PrefixGroupsDialogComponent, {
      dialogData,
      title: 'Edit prefix group',
      onSubmit: this.isUnauthorized ? null : () => {
        return this.prefixGroupsApiService.editPrefixGroup(dialogData.selectedItem, dialogData.selectedItem.id).toPromise().then(() => {
          this.refresh();
          this.snackBarService.display(`${dialogData.selectedItem.name} successfully updated`);
        });
      }
    });
  }

  private setSearchOptions(): void {
    this.searchData = {
      prefixTypeOptions: this.prefixTypeOptions
    };
  }
}
